<template>
  <div>
    <LexonTooltipComponent v-if="isIAFile" :icon="icon" :message="tooltipMessage" position="top" :isWidthAuto="true" />
  </div>
</template>
<script lang="ts">
import { isDocsIAFile } from '@/components/FileManager/components/utils'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import { getFileDotExtension } from '@/helpers/file'
import { Icons } from '@/icons/icons'
import { Vue, Component } from 'vue-property-decorator'
import useDocsIA from '@/components/FileManager/components/DocsIA/composables/useDocsIA'

@Component({
  name: 'DocsIATemplateComponent',
  components: {
    LexonTooltipComponent
  }
})
export default class DocsIATemplateComponent extends Vue {
  data: any

  icon = Icons.IA

  tooltipMessage = this.$t('Análisis documental disponible')

  private docsIA = useDocsIA()

  get fileName() {
    return this.data?.initialFile ?? ''
  }

  get isIAFile() {
    return isDocsIAFile(getFileDotExtension(this.fileName)) && this.docsIA.showDocsIA
  }
}
</script>
<style lang="scss">
.lf-icon-ia.tooltip-icon {
  margin-left: -20px;
  &::before {
    color: $highlight-200;
  }
}
</style>
